import css from 'styled-jsx/css';
import { colors, typography } from '../../../config/styles';

const style = css`
  .list-container {
    margin: 0 8px 24px 8px;
    padding-top: 2.4rem;
    border-top: 1px solid ${colors.gray.shade46};
    @mixin mobileToTablet {
      border-top: none;
    }
    .items-container {
      overflow-y: auto;
      max-height: 230px;
      padding-right: 4px;
    }
  }
  .lists-title {
    font-size: ${typography.lg1};
    margin-bottom: 1em;
    font-weight: 700;
    line-height: 19px;
    color: ${colors.gray.shade15};
  }
`;
export { style };
